export function useType() {
  const columns = [
    {
      title: '图片',
      dataIndex: 'imageUrl',
      key: 'imageUrl'
    },
    {
      title: '名称',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: '获取类型',
      dataIndex: 'type',
      key: 'type',
      customRender({ text }) {
        const ival = {
          1: '每日登录',
          2: '积分兑换',
          3: '邮件订阅'
        }
        return ival[text]
      } //1.每日登录,2.积分兑换
    },
    {
      title: '描述',
      dataIndex: 'description',
      key: 'description'
    },
    {
      title: '获取规则',
      dataIndex: 'rules',
      key: 'rules'
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status'
    },
    {
      title: '操作',
      dataIndex: 'actions',
      key: 'actions'
    }
  ]

  const rules = {
    type: [
      { required: true, trigger: 'change', message: '请选择获取方式类型' }
    ],
    scenesId: [
      { required: true, trigger: 'blur', message: '请输入积分发放场景ID' }
    ],
    name: [{ required: true, trigger: 'change', message: '请输入名称' }],
    description: [{ required: true, trigger: 'change', message: '请输入描述' }],
    imageUrl: [{ required: true, trigger: 'change', message: '请选择图片' }],
    integralPerConsumption: [
      { required: true, trigger: 'change', message: '请输入积分' }
    ],
    dailyExchangeLimit: [
      { required: true, trigger: 'change', message: '请输入兑换上限' }
    ],
    countPerLogin: [
      { required: true, trigger: 'change', message: '请输入获取机会次数' }
    ],
    countPerSubscribe: [
      { required: true, trigger: 'change', message: '请输入获取机会次数' }
    ],
    status: [{ required: true, trigger: 'change', message: '请选择状态' }],
    chanceNeverExpires: [
      { required: true, trigger: 'change', message: '请选择每日是否清零' }
    ]
  }
  return { columns, rules }
}
